<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="patient-insider-reading-list"
    :style="{
      backgroundColor: backgroundColor,
      backgroundImage: `url(${backgroundImage})`,
    }"
  >
    <img
      class="patient-insider-reading-list__image"
      :src="mainImageUrl"
      :alt="mainImageAlt"
    >
    <div class="patient-insider-reading-list__content">
      <h2 class="patient-insider-reading-list__heading">{{ heading }}</h2>
      <div
        class="patient-insider-reading-list__copy"
        v-html="copy"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatientInsiderReadingList',
  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
    backgroundMedia: {
      type: Array,
      default: () => [],
    },
    mainMedia: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      default: '',
    },
    copy: {
      type: String,
      default: '',
    },
  },
  computed: {
    backgroundImage() {
      return this.backgroundMedia
        && this.backgroundMedia[0]
        && this.backgroundMedia[0].url;
    },
    mainImageUrl() {
      return this.mainMedia
        && this.mainMedia[0]
        && this.mainMedia[0].url;
    },
    mainImageAlt() {
      return this.mainMedia
        && this.mainMedia[0]
        && this.mainMedia[0].alt;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_patient-insider-reading-list';
</style>

<style lang="scss"> // no scoped - to reach HTML content
  .patient-insider-reading-list__copy {
    p {
      margin-bottom: $spacing * 3;
      padding: 0 ($spacing * 2);
    }

    ul {
      margin-bottom: $spacing * 2;
    }
  }
</style>
